// removed by extract-text-webpack-plugin
module.exports = {"splash":"splash__1twYO","brand":"brand__x1hA7"};


//////////////////
// WEBPACK FOOTER
// ./components/splash/style.css
// module id = 7rrU
// module chunks = 6